import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import NotificationList from 'flarum/forum/components/NotificationList';
import { NOTIFICATION } from './realtimeEvents';

/**
 * Shares `app.notifications` with the header dropdown, so reading a
 * notification in one place updates the other.
 */
export default class NotificationsSource {
  load() {
    return app.notifications.load();
  }
  view() {
    return m(NotificationList, {
      state: app.notifications
    });
  }
  async checkForNew() {
    return (await this.unshown()).filter(notification => !notification.isRead()).length;
  }
  async applyNew() {
    const firstPage = app.notifications.getPages()[0];
    if (!firstPage) return null;
    const unshown = await this.unshown();
    firstPage.items.unshift(...unshown);
    return unshown.length;
  }

  /** Per-member and indexed by user, so the newest few are a cheap question. */
  async unshown() {
    const latest = await app.store.find('notifications', {
      page: {
        limit: 10,
        total: 0
      }
    });
    const shown = new Set(app.notifications.getPages().flatMap(page => page.items).map(notification => notification.id()));
    return latest.filter(notification => !shown.has(notification.id()));
  }

  /** Realtime sends each new notification on the member's channel: shown at once, no request. */
  onRealtime(event) {
    if (event.name !== NOTIFICATION || event.model?.data?.type !== 'notifications') return;
    const firstPage = app.notifications.getPages()[0];
    const notification = event.model;
    if (!firstPage || firstPage.items.some(item => item.id() === notification.id())) return;
    firstPage.items.unshift(notification);
    return 'inserted';
  }
  showNew() {
    return app.notifications.revalidate();
  }
  controls(items) {
    items.add('markAllAsRead', m(Button, {
      icon: "fas fa-check",
      onclick: () => app.notifications.markAllAsRead()
    }, app.translator.trans('core.forum.notifications.mark_all_as_read_tooltip')));
  }
}
flarum.reg.add('flarum-deck', 'forum/columns/NotificationsSource', NotificationsSource);